<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-12 col-md-6 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Entity_Name">Entity Name</label>
              <input
                myFocus
                type="text"
                name="Entity_Name"
                [(ngModel)]="dsCollection.criteria.Entity_Name"
                ngControl="Entity_Name"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Entity_Quick_Search">Quick Search</label>
              <input
                type="text"
                name="Entity_Quick_Search"
                [(ngModel)]="dsCollection.criteria.Entity_Quick_Search"
                ngControl="Entity_Quick_Search"
              />
            </div>
          </div>

          <div class="col-12 col-lg-4">
            <unity-button-old
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              classes="primary"
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              [dirty]="model.dirty"
            >
              Search
            </unity-button-old>
            <unity-button-old
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="button"
              (click)="
                dsCollection.criteria.Entity_Name = '';
                dsCollection.criteria.Entity_Quick_Search = '';
                model.dirty = true
              "
              classes="secondary"
            >
              Reset
            </unity-button-old>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #brokerFilter
          style="margin-bottom: 5px"
          [filter]="{ filterKey: '[GLOBAL]', maxDepth: 5 }"
        ></ep-filter-input>

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>

        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header">
            <tr *ngIf="dsCollection.objectNodes && dsCollection.objectNodes.length > 0">
              <th>Entity Name</th>
              <th>Email Address</th>
              <th>Alternate Reference</th>
            </tr>
            <tr
              *ngFor="
                let broker of dsCollection.objectNodes | epFilter : brokerFilter.filter : brokerFilter.filter.filterText
              "
              (click)="app.getSelectedText() && select(broker)"
            >
              <td>
                {{ broker.Entity_Name }}
              </td>
              <td>
                {{ broker.Email_Address }}
              </td>
              <td>
                {{ broker.Search_Ref }}
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Brokers</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
